import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useRef } from 'react'

export function DiscardDialog({
  open,
  includesSharing,
  onDiscard,
  onKeepEditing,
}: {
  open: boolean
  /** Sharing is a draft edit too, saved with the rest. */
  includesSharing: boolean
  onDiscard: () => void
  onKeepEditing: () => void
}) {
  // No trigger: Radix would return focus to a missing one, i.e. the body.
  const openerRef = useRef<HTMLElement | null>(null)
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onKeepEditing()
      }}>
      <AlertDialogContent
        size="sm"
        onOpenAutoFocus={() => {
          openerRef.current =
            document.activeElement instanceof HTMLElement
              ? document.activeElement
              : null
        }}
        onCloseAutoFocus={(event) => {
          event.preventDefault()
          openerRef.current?.focus()
        }}>
        <AlertDialogHeader>
          <AlertDialogTitle>Discard changes?</AlertDialogTitle>
          <AlertDialogDescription>
            {includesSharing
              ? 'Your edits, including sharing, are not saved. Closing the editor discards them.'
              : 'Your edits are not saved. Closing the editor discards them.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep editing</AlertDialogCancel>
          <AlertDialogAction variant="destructive" onClick={onDiscard}>
            Discard
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
